import React, { useEffect, useState } from 'react';
import { useRootStore } from '../../stores/BridgeProvider';
import Spinner from '../util/Spinner';

const DealMapperContainer = ({
  dealIds,
  voucherIds,
  invoiceDeal,
  children,
}) => {
  const { dealMapperStore } = useRootStore();
  const [loading, setLoading] = useState(true);
  const loadInfo = async () => {
    await dealMapperStore.loadData({ dealIds, voucherIds });
    setLoading(false);
    return dealMapperStore.reset();
  };
  useEffect(() => {
    const initialize = async () => {
      await loadInfo();
      if (invoiceDeal) dealMapperStore.voucherDeals();
    };
    initialize();
  }, []);

  return loading ? <Spinner /> : children;
};

export default DealMapperContainer;
